export default [
  {
    path: '/auth/client/:token',
    name: 'ClientToken',
    component: () => import('@/views/auth/ClientToken.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      notRedirectIfNotLoggedIn: true,
      notRedirectIfLoggedIn: true,
      action: 'read',
    },
  },
]
